import { GallerySearchMode } from '../models/gallery-search-mode.enum';
import { GalleryViewMode } from '../models/gallery-view-mode.enum';
import { StudioOptionsModel } from '../models/studio-options.model';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';
import { SearchConfigUnion } from '../models/search-config';
import { SearchOptions } from '../models/search-options';
import { GalleryResultsModel } from '../models/gallery-results.model';
import { BulkActions } from '../models/bulk-action';
import { BookmarkAction } from '../../bookmarks/models/bookmark-action';

export class GalleryStateModel {
  loading: boolean;

  searchMode: GallerySearchMode;
  viewMode: GalleryViewMode;

  searchResults: GalleryResultsModel;
  checkedResults: string[];

  // New
  searchConfig: SearchConfigUnion;
  searchOptions: SearchOptions;

  sidenav: GallerySidenav;

  bulkActions: GalleryBulkActions;
  cardActions: GalleryCardActions;
}

export class GallerySidenav {
  enabled: boolean;
  open: boolean;
  disableClose: boolean;
}

export class GalleryBulkActions {
  enabled: boolean;
  items: BulkActions[];
}

export class GalleryCardActions {
  enabled: boolean;
}
